<p-tabView #tabview>
    <p-tabPanel header="Top 10" fxLayout="column">
        <p-table *ngIf="showTable" selectionMode="multiple" [value]="tableDataTop10" scrollable="true" [rows]="12" scrollHeight="100%" [paginator]="false" styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th>External ID</th>
                    <th>Currency</th>
                    <th>Direction</th>
                    <th>Account</th>
                    <th>Trade Date</th>
                    <th>Client</th>
                    <th>Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{row.externalID}}</td>
                    <td>{{row.currency}}</td>
                    <td>{{row.direction}}</td>
                    <td>{{row.account}}</td>
                    <td>{{row.tradeDatetime}}</td>
                    <td>{{row.client}}</td>
                    <td>
                        <span [style]="{'text-align':'center'}">{{row.amount | currencyrounding:2:currency:'symbol-narrow' }}</span>
                    </td>
                </tr>
            </ng-template>
<!-- 
            <p-column [styleClass]="'col-external-ref'" field="externalID" header="External ID" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-currency'" field="currency" header="Currency" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-direction'" field="direction" header="Direction" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-account'" field="account" header="Account" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-trade-date-time'" field="tradeDatetime" header="Trade Date" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-client'" field="client" header="Client" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-amount'" field="amount" header="Amount" [sortable]="true" [style]="{'text-align':'center'}">
                <ng-template let-row="rowData" pTemplate="body">
                    <span>{{row.amount | currencyrounding:2:currency:'symbol-narrow' }}</span>
                </ng-template>
            </p-column> -->
        </p-table>
    </p-tabPanel>
    <p-tabPanel header="Last 10" fxLayout="column">
        <p-table *ngIf="showTable" selectionMode="multiple" [value]="tableDataLast10" scrollable="true" [rows]="12" scrollHeight="100%" [paginator]="false" styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th>External ID</th>
                    <th>Currency</th>
                    <th>Direction</th>
                    <th>Account</th>
                    <th>Trade Date</th>
                    <th>Client</th>
                    <th>Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{row.externalID}}</td>
                    <td>{{row.currency}}</td>
                    <td>{{row.direction}}</td>
                    <td>{{row.account}}</td>
                    <td>{{row.tradeDatetime}}</td>
                    <td>{{row.client}}</td>
                    <td>
                        <span [style]="{'text-align':'center'}">{{row.amount | currencyrounding:2:currency:'symbol-narrow' }}</span>
                    </td>
                </tr>
            </ng-template>

            <!-- <p-column [styleClass]="'col-external-ref'" field="externalID" header="External ID" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-currency'" field="currency" header="Currency" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-direction'" field="direction" header="Direction" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-account'" field="account" header="Account" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-trade-date-time'" field="tradeDatetime" header="Trade Date" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-client'" field="client" header="Client" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
            <p-column [styleClass]="'col-amount'" field="amount" header="Amount" [sortable]="true" [style]="{'text-align':'center'}">
                <ng-template let-row="rowData" pTemplate="body">
                    <span>{{row.amount | currencyrounding:2:currency:'symbol-narrow' }}</span>
                </ng-template>
            </p-column> -->
        </p-table>
    </p-tabPanel>
</p-tabView>
